class ModalHandler {
  constructor() {
    this.currentModal = null;
    this.originalScrollTopDescriptor = null;
    this.init();
    this.observeDOM();
  }

  init() {
    document.querySelectorAll('.modal-link:not([data-modal-init])').forEach((link) => {
      link.setAttribute('data-modal-init', 'true');
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const modalId = link.getAttribute('data-modal-id');
        this.showModal(modalId);
      });
    });

    // Modal overlay click
    document.querySelectorAll('.modal-window-overlay:not([data-modal-init])').forEach((modal) => {
      modal.setAttribute('data-modal-init', 'true');
      modal.addEventListener('click', (event) => {
        if (event.target === modal) {
          this.hideModal(modal.id);
        }
      });
    });

    // NEW: ensure placement immediately when modal appears in DOM
    document
      .querySelectorAll('.modal-window-overlay[data-placement="body"]:not([data-placement-applied])')
      .forEach((modal) => {
        if (modal.parentNode !== document.body) {
          document.body.appendChild(modal);
        }
        modal.setAttribute('data-placement-applied', 'true');
      });
  }

  observeDOM() {
    const observer = new MutationObserver(() => this.init());
    observer.observe(document.body, { childList: true, subtree: true });
  }

  blockScrollTop() {
    const root = document.scrollingElement || document.documentElement;
    const proto = Object.getPrototypeOf(root);

    this.originalScrollTopDescriptor =
      Object.getOwnPropertyDescriptor(proto, 'scrollTop') || Object.getOwnPropertyDescriptor(root, 'scrollTop');

    Object.defineProperty(root, 'scrollTop', {
      configurable: true,
      enumerable: this.originalScrollTopDescriptor ? this.originalScrollTopDescriptor.enumerable : true,
      get: () => 0,
      set: () => {},
    });
  }

  restoreScrollTop() {
    if (!this.originalScrollTopDescriptor) return;
    const root = document.scrollingElement || document.documentElement;
    const proto = Object.getPrototypeOf(root);

    Object.defineProperty(proto, 'scrollTop', this.originalScrollTopDescriptor);

    this.originalScrollTopDescriptor = null;
  }

  showModal(modalId) {
    if (!modalId) return;
    let modal = document.getElementById(modalId);
    if (!modal) return;

    modal.classList.add('show');
    document.body.classList.add('modal-opened');
    document.documentElement.classList.add('modal-opened');

    this.blockScrollTop();

    this.currentModal = modal;
  }

  hideModal(modalId) {
    if (!modalId) return;
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove('show');
      if (this.currentModal === modal) {
        this.currentModal = null;
      }
    }
    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');

    this.restoreScrollTop();
  }

  closeCurrentModal() {
    if (this.currentModal) {
      this.currentModal.classList.remove('show');
      this.currentModal = null;
    }
    document.body.classList.remove('modal-opened');
    document.documentElement.classList.remove('modal-opened');
    this.restoreScrollTop();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.modalHandler = new ModalHandler();
});
